<template>
  <div class="locationSelector">
    <v-container fluid>
      <p>Locatie</p>
      <v-select
        v-model="selectedLocation"
        :items="locationItems"
        item-text="title"
        outlined
        required
        v-on:change="selected"
      ></v-select>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { services } from "../_services";
import { mapActions } from "vuex";

export default {
  props: {
    formModel: Object,
    resetData: Boolean,
  },
  data: function () {
    return {
      selectedLocation: {
        id: 0,
        title: "--Selecteer de gewenste locatie--",
        description: "",
        mediaLink: "",
      },
      locationItems: [
        {
          id: 0,
          title: "--Selecteer de gewenste locatie--",
          description: "",
          mediaLink: "",
        },
      ],
    };
  },
  computed: {
    complaintTypeChange() {
      return this.formModel.categoryId;
    },
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      showAlert: "alert/error",
      selectComp: "appBar/selectComp",
      updateFormModel: "appBar/updateFormModel",
    }),
    selected(option) {
      var location = this.locationItems.find((x) => x.title == option);
      var title = location.title;
      var $this = this;

      if (location.id == 0) {
        this.updateFormModel({
          formModel: { id: 3, title: "", selected: false },
          callback: function () {
            $this.selectComp({
              id: 3,
              type: "select",
              resetData: true,
              emptySelection: true,
            });
          },
        });
        return;
      }
      this.updateFormModel({
        formModel: {
          id: 3,
          title: title,
          locatieId: parseInt(location.id, 10),
          locatieName: location.title,
          selected: true,
        },
        callback: function () {
          $this.selectComp({
            id: 4,
            type: "select",
            resetData: true,
            emptySelection: false,
          });
        },
      });
    },
    clearOptions() {
      if (this.resetData == true) {
        this.selectedLocation = this.locationItems[0];
        this.updateFormModel({
          formModel: {
            id: 3,
            title: "",
            locatieId: parseInt(this.selectedLocation.id, 10),
            locatieName: this.selectedLocation.title,
            selected: false,
          },
        });
      }
    },
  },
  watch: {
    complaintTypeChange() {
      if (this.formModel.categoryId != 0) {
        services.fetchLocatie(this.formModel).then(
          (data) => {
            this.locationItems = [{ id: 0, title: "--Selecteer de gewenste locatie--", description: "", mediaLink: "" }]
            this.locationItems = this.locationItems.concat(data);
            // this.locationItems.pop();

            if (this.locationItems.length <= 2) {
              this.selectedLocation = this.locationItems[1];
              this.selected(this.selectedLocation.title);
            }
          },
          (error) => {
            this.showAlert(error);
          }
        );
      } else {
            this.updateFormModel({
            formModel: {
                id: 3,
                title: "",
                locatieId: 0,
                locatieName: this.selectedLocation.title,
                selected: false,
            },
            });
      }
    },
    resetData() {
      this.clearOptions();
    },
  },
};
</script>